/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Patient API
 * API for Patient
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PutPatientAgreementRequestBodyTypename = "PutPatientAgreementRequestBody" as const;

/**
 *
 * @export
 * @interface PutPatientAgreementRequestBody
 */
export interface PutPatientAgreementRequestBody {
  /**
   *
   * @type {boolean}
   * @memberof PutPatientAgreementRequestBody
   */
  agreement: boolean;
  /**
   * Resource type name
   * @type {string}
   * @memberof PutPatientAgreementRequestBody
   */
  readonly __typename?: string;
}

export function PutPatientAgreementRequestBodyFromJSON(json: any): PutPatientAgreementRequestBody {
  return PutPatientAgreementRequestBodyFromJSONTyped(json, false);
}

export function PutPatientAgreementRequestBodyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PutPatientAgreementRequestBody {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PutPatientAgreementRequestBodyTypename,

    agreement: json["agreement"],
  };
}

export function PutPatientAgreementRequestBodyToJSON(object?: PutPatientAgreementRequestBody | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    agreement: value.agreement,
  };
}
